// console.log

export default class {
	static startLoading(pElemId, pCallback) {
		var imgLoad = imagesLoaded(pElemId);
		var _total = imgLoad.images.length;
		var _current = 0;
		imgLoad.on('progress', function (instance, image) {
			_current++;
			var _percentage = Math.floor((_current / _total) * 100);
		});
		imgLoad.on('always', function (instance, image) {
			if (typeof pCallback === 'function') pCallback();
		});
	}

	static scrollTo(target) {
		gsap.to($('html, body'), .7, {scrollTop:$(target).offset().top-$('header').height(), ease:Cubic.easeInOut});
	}
}